var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('PageHeader'),_c('router-view'),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }